import { ApplicationErrorActions, ErrorDetails } from './types';
import { useState } from 'react';

import styles from './ApplicationError.module.css';

/**
 * Component responsible for rendering the determined type of action for the Error page. At the time of implementation
 * this is limited to different types of button actions.
 */
export default function ApplicationErrorAction(props: { errorDetails: ErrorDetails; actionColor: string }) {
	/**
	 * Typically we are keeping styling in css, but because the MUI css variables may not be present at the time this
	 * component is rendered we need to handle the color styles manually. Remaining styles are done in css.
	 */
	const [hovered, setHovered] = useState(false);

	const buttonStyle = {
		color: props.actionColor,
		borderColor: `${props.actionColor}80`
	};

	const hoverStyle = {
		borderColor: props.actionColor,
		backgroundColor: `${props.actionColor}14`
	};

	const handleClick = () => {
		switch (props.errorDetails.action) {
			case ApplicationErrorActions.Back: {
				history.back();
				break;
			}

			case ApplicationErrorActions.Home: {
				document.location.href = '/';
				break;
			}

			case ApplicationErrorActions.Refresh: {
				window.location.reload();
				break;
			}

			case ApplicationErrorActions.Custom: {
				props.errorDetails.customAction?.action();
				break;
			}

			default:
				break;
		}
	};

	return (
		<>
			<button
				type='button'
				className={styles.button}
				style={{
					...buttonStyle,
					...(hovered ? hoverStyle : {})
				}}
				onClick={() => {
					handleClick();
				}}
				onMouseEnter={() => {
					setHovered(true);
				}}
				onMouseLeave={() => {
					setHovered(false);
				}}
			>
				{props.errorDetails.action === ApplicationErrorActions.Custom && props.errorDetails.customAction?.buttonText
					? props.errorDetails.customAction.buttonText
					: props.errorDetails.action}
			</button>
		</>
	);
}
